/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';
import type { InlineNotificationProps } from '@coursera/cds-core';

const styles = {
  container: css`
    margin: 25px 0;
  `,
};

type Props = Pick<InlineNotificationProps, 'severity' | 'title'> & {
  children: string & React.ReactNode;
};

const Highlight = ({ children, severity = 'information', title = 'Note' }: Props) => (
  <div css={styles.container}>
    <InlineNotification title={title} severity={severity}>
      {children}
    </InlineNotification>
  </div>
);

export default Highlight;
